import {GridSortCellParams} from "@mui/x-data-grid/models/gridSortModel";

export class GridComparator {
    static formattedStringComparator<T>(getFormattedValue: (value: T) => string): (v1: T, v2: T, cellParams1: GridSortCellParams, cellParams2: GridSortCellParams) => number {
        return (v1, v2, cellParams1, cellParams2) => {
            const formattedV1 = getFormattedValue(cellParams1.value);
            const formattedV2 = getFormattedValue(cellParams2.value);
            return formattedV1.localeCompare(formattedV2);
        };
    }
}
